import React from 'react';
import { TrendingUp } from 'lucide-react';

// Equivalente genérico de GraficoResultados.js — recebe prop `itens` no
// formato {slug,label,votos,percentual,ativa} em vez de `locais`, pra não
// precisar tocar no componente original (usado hoje pelo Telão Brasil).
const GraficoResultadosGenerico = ({ itens, totalRespondentes }) => {
  if (!itens || itens.length === 0) return null;

  const ordenados = [...itens].sort((a, b) => b.votos - a.votos);

  const getMedalha = (posicao) => {
    switch (posicao) {
      case 0: return '🏆';
      case 1: return '🥈';
      case 2: return '🥉';
      default: return '';
    }
  };

  const getCor = (posicao) => {
    const cores = [
      'from-yellow-400 to-amber-500',
      'from-gray-300 to-gray-400',
      'from-orange-400 to-orange-500',
      'from-blue-400 to-blue-500',
      'from-purple-400 to-purple-500',
      'from-pink-400 to-pink-500'
    ];
    return cores[posicao] || 'from-gray-400 to-gray-500';
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 space-y-3">
      {ordenados.map((item, index) => {
        const porcentagem = totalRespondentes > 0
          ? ((item.votos / totalRespondentes) * 100).toFixed(1)
          : 0;
        const isVencedor = index === 0 && item.votos > 0;
        const isTop3 = index < 3 && item.votos > 0;

        return (
          <div
            key={item.slug}
            className={`transition-all duration-300 ${isVencedor ? 'bg-yellow-50 border-2 border-yellow-300 rounded-xl p-3' : 'p-1'}`}
          >
            <div className="flex items-center justify-between mb-1 flex-wrap gap-2">
              <div className="flex items-center gap-2 flex-1 min-w-0">
                {isTop3 && <span className="text-lg flex-shrink-0">{getMedalha(index)}</span>}
                <span className={`truncate ${isVencedor ? 'font-bold text-gray-900' : 'text-gray-700'} ${!item.ativa ? 'italic text-gray-400' : ''}`}>
                  {item.label}
                  {!item.ativa && <span className="text-xs ml-1">(removida do formulário)</span>}
                </span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0 text-sm">
                <span className="font-semibold text-gray-900">{item.votos.toLocaleString('pt-BR')}</span>
                <span className="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs font-medium">{porcentagem}%</span>
              </div>
            </div>

            <div className="relative w-full bg-gray-200 rounded-full h-3 overflow-hidden">
              <div
                className={`h-3 rounded-full bg-gradient-to-r ${getCor(index)} transition-all duration-700`}
                style={{ width: `${Math.max(parseFloat(porcentagem), item.votos > 0 ? 2 : 0)}%` }}
              />
            </div>
          </div>
        );
      })}

      {totalRespondentes > 0 && (
        <p className="text-xs text-gray-400 flex items-center gap-1 pt-1">
          <TrendingUp className="w-3 h-3" /> Percentual calculado sobre {totalRespondentes} respondente(s)
        </p>
      )}
    </div>
  );
};

export default GraficoResultadosGenerico;
